<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-dialog v-model="dialogLocal" scrollable max-width="1000px" :persistent="notesChangedCounter > 0">
            <v-card>
                <v-card-title>
                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">{{ formTitle }}</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn class="pr-5" color="blue darken-1" text @click="closeDialog">Close</v-btn>
                </v-card-actions>
                <v-card-text id="resultDataId">
                    <div v-for="test in tests" :key="test.eyes[0].visitId">
                        <TestNotes v-if="test.eyes[0].errCode !== null && 0 === test.eyes[0].errCode" :mrn="test.mrn" :resultData="test.eyes[0]" :resetData="resetData" @save-note="saveNote" @note-changed="noteChangedFunc"/>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <ConfirmationDialog v-if="confirmLoseChanges" :params="confirmLoseChangesParams" @confirmation-dialog-response="confirmLoseChangesHandler"></ConfirmationDialog>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import TestNotes from '@/components/test-notes'
    import ConfirmationDialog from '@/components/confirmation-dialog'

    export default
    {
        name: 'mrn-notes-dialog',
        components:
        {
            TestNotes,
            ConfirmationDialog
        },
        data: function ()
        {
            return {
                dialogLocal: false,
                notesChangedCounter: 0,
                confirmLoseChanges: false,
                confirmLoseChangesParams:
                {
                    title: 'About to Lose Changes',
                    text: 'You have one or more unsaved notes. Lose changes?',
                    positiveResponse: 'Yes',
                    negativeResponse: 'No'
                },
                resetData: false
            }
        },
        props:
        {
            dialog: Boolean(false)
        },
        computed:
        {
            ...mapState('tests',
            {
                tests: state => state.tests
            }),
            formTitle()
            {
                return `Notes for Patient ID: ${this.tests && this.tests.length > 0 ? this.tests[0].mrn : ''}`
            }
        },
        watch:
        {
            dialogLocal(val)
            {
                // If the dialog is being closed
                if (!val)
                {
                    this.$emit('dialog-close')
                }
                else // Else the dialog is being opened
                {
                    this.$logEvent(this.$firebaseAnalytics, 'screen_view',
                    {
                        app_name: 'Web Portal',
                        screen_name: `Reflex Web Portal - ${this.$options.name}`,
                        app_version: process.env.VUE_APP_VERSION
                    });
                    this.dialogLocal = val
                }
            },
            dialog(val)
            {
                this.resetData = !val;
                this.dialogLocal = val
            }
        },
        methods:
        {
            closeDialog()
            {
                if (this.notesChangedCounter > 0)
                {
                    this.confirmLoseChanges = true;
                    return
                }
                this.postClose()
            },
            postClose()
            {
                document.getElementById('resultDataId').scrollTop = 0;
                this.dialogLocal = false
            },
            saveNote: function()
            {
                this.notesChangedCounter--
            },
            noteChangedFunc: function(needToSave)
            {
                if (needToSave)
                {
                    this.notesChangedCounter++
                }
                else
                {
                    this.notesChangedCounter--
                }
            },
            confirmLoseChangesHandler(payload)
            {
                this.confirmLoseChanges = false;
                // If the changes should be lost
                if (payload.response)
                {
                    this.postClose()
                }
            }
        }
    };
</script>

<style scoped>
</style>